// extracted by mini-css-extract-plugin
export default {"openLetterContent":"styles_openLetterContent__g9lkG","previewButton":"styles_previewButton__6FH-r","names":"styles_names__WmXhQ"};